import { Link, useParams } from "react-router-dom";

export const PlayerLegalFooter = () => {
  const { clientSlug } = useParams<{ clientSlug: string }>();
  const slug = clientSlug || "default";
  return (
    <footer className="relative z-10 mt-auto w-full py-4 px-4">
      <nav className="mx-auto flex max-w-2xl flex-wrap items-center justify-center gap-x-4 gap-y-1 text-xs text-muted-foreground">
        <Link to={`/c/${slug}/legal/mentions`} className="transition-colors hover:text-foreground">
          Mentions légales
        </Link>
        <span className="opacity-40" aria-hidden="true">•</span>
        <Link to={`/c/${slug}/legal/confidentialite`} className="transition-colors hover:text-foreground">
          Confidentialité
        </Link>
        <span className="opacity-40" aria-hidden="true">•</span>
        <Link to={`/c/${slug}/legal/reglement`} className="transition-colors hover:text-foreground">
          Règlement du jeu
        </Link>
        <span className="opacity-40" aria-hidden="true">•</span>
        <span className="opacity-70">Développé par Iaora Labs</span>
      </nav>
    </footer>
  );
};
